import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { PartSearchColumnChoice } from '../../components/PartDetailedSearch/PartDetailedSearchColumnChooserMenu';
import { QuoteBuilderStateType } from '../../types/state';

export function partSearchColumnsUpdated(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<PartSearchColumnChoice[]>,
) {
  state.partSearchColumns = action.payload;
}
